// extracted by mini-css-extract-plugin
export default {"fadeIn":"FirstImageDIv_fadeIn__OiQyo","fadeInOpacity":"FirstImageDIv_fadeInOpacity__E8vKo"};